import React, { useEffect, useState } from "react"
import DatePicker from "../Datepicker"
import moment from "moment-timezone"
import updateQueryString from "./updateQs"
import isOnDemand from "../../utils/isOnDemand"
import qs from "query-string"
import { addBusinessDays, format, parse } from "date-fns"
import minDateGap from "../../utils/minDateGap"
import OnDemandTypeSelector from "../OnDemandTypeSelector"
import OnDemandTimePicker from "../OnDemandTypeSelector/TimePicker"
import { cities } from "../../config"

export const getField = (
  type,
  id,
  value,
  setValue,
  setFilter,
  title,
  holidays = []
) => {
  let formItem = ""
  switch (type) {
    case "date_picker":
      formItem = (
        <DatepickerWrapper
          id={id}
          value={value}
          setValue={setValue}
          setFilter={setFilter}
          holidays={holidays}
        />
      )
      break
    case "current_staff":
      formItem = (
        <TeamSize
          id={id}
          setValue={(value) => setValue(value)}
          value={value}
          setFilter={setFilter}
          title={title}
        />
      )
      break
    case "location":
      formItem = (
        <Location
          id={id}
          setValue={(value) => setValue(value)}
          value={value}
          setFilter={setFilter}
        />
      )
      break
    default:
      formItem = ""
      break
  }

  return formItem
}

const Location = ({ id, value, setValue, setFilter = () => null }) => {
  useEffect(() => {}, [])
  const updateValue = (e) => {
    updateQueryString(id, e.target.value)
    setValue(e.target.value)
    setFilter()
  }
  return (
    <div className={"location-filter-item-wrapper"}>
      {cities.map((city) => (
        <div className={"form-group custom-radio"} key={city}>
          <label className="radio-input">
            <input
              type="radio"
              name={id}
              value={city}
              checked={city === value}
              onChange={updateValue}
            />
            <span>{city}</span>
          </label>
        </div>
      ))}
    </div>
  )
}

const DatepickerWrapper = ({
  id,
  value,
  setValue,
  setFilter = () => null,
  holidays = [],
}) => {
  const spaceSummary =
    typeof window !== "undefined" ? qs.parse(window.location.search) : ""

  const [date, setDate] = useState(
    spaceSummary && spaceSummary.move_in_date
      ? new Date(moment.tz(spaceSummary.move_in_date, moment.tz.guess()))
      : ""
  )

  const [endDate, setEndDate] = useState(
    spaceSummary && spaceSummary.move_out_date
      ? new Date(moment.tz(spaceSummary.move_out_date, moment.tz.guess()))
      : ""
  )

  const updateDatepicker = (date) => {
    const formattedDate = moment(date).format("YYYY-MM-DD")
    setDate(date)
    setValue(formattedDate)
    updateQueryString(id, formattedDate)

    setFilter(null)
  }

  const [startTime, setStartTime] = useState(
    spaceSummary.move_in_date && spaceSummary.start_time
      ? parse(
          `${spaceSummary.move_in_date} ${spaceSummary.start_time}`,
          "yyyy-MM-dd h:mm a",
          new Date()
        )
      : ""
  )
  const [endTime, setEndTime] = useState(
    spaceSummary.move_in_date && spaceSummary.end_time
      ? parse(
          `${spaceSummary.move_in_date} ${spaceSummary.end_time}`,
          "yyyy-MM-dd h:mm a",
          new Date()
        )
      : ""
  )
  const [isDaily, setIsDaily] = useState(
    spaceSummary && spaceSummary.on_demand_type !== "Hourly"
  )

  const [mobileMessage, setMobileMessage] = useState("")

  const setDaily = (value) => {
    setIsDaily(value)
    setDate(null)
    setEndDate(null)
    setStartTime("")
    setEndTime("")
  }

  const updateOnDemandPicker = (dates) => {
    if (!isDaily) {
      setDate(dates)
      setEndDate(null)
      setStartTime("")
      setEndTime("")
      return
    }
    const [start, end] = dates
    if (start && !end) {
      setDate(start)
      setEndDate(null)
    } else if (start && end) {
      setDate(start)
      setEndDate(end)
      setIsDaily(true)
      updateQueryString(
        `${id},move_out_date,on_demand_type`,
        `${moment(start).format("YYYY-MM-DD")},${moment(end).format(
          "YYYY-MM-DD"
        )},Daily`
      )
      setTimeout(() => {
        setFilter(null)
      }, 50)
    }
  }

  const setET = (value) => {
    setEndTime(value)
    if (date && startTime) {
      setIsDaily(false)
      updateQueryString(
        `${id},move_out_date,on_demand_type,start_time,end_time`,
        `${moment(date).format("YYYY-MM-DD")},${moment(date).format(
          "YYYY-MM-DD"
        )},Hourly,${format(startTime, "h:mm a")},${format(value, "h:mm a")}`
      )
      setTimeout(() => {
        setFilter(null)
      }, 50)
    }
  }

  useEffect(() => {
    if (isDaily) {
      if (!date) {
        setMobileMessage("Please select a start date")
      } else {
        setMobileMessage("Please select an end date")
      }
      if (date && endDate) {
        setMobileMessage("")
      }
    } else {
      if (!date) {
        setMobileMessage("Please select a date")
      } else {
        setMobileMessage("Please select start & end time")
      }
      if (date && startTime && endTime) {
        setMobileMessage("")
      }
    }
  }, [date, endDate, startTime, endTime])

  if (isOnDemand()) {
    return (
      <div>
        {mobileMessage && (
          <div className={"d-sm-none ws-filter-mobile-messages"}>
            <span>{mobileMessage}</span>
          </div>
        )}
        <OnDemandTypeSelector
          isDaily={isDaily}
          setDaily={() => setDaily(true)}
          setHourly={() => setDaily(false)}
          className={`mb-4 mb-sm-3 mt-4 mt-sm-0`}
        />
        <DatePicker
          value={date}
          maxDate={addBusinessDays(new Date(), 28)}
          minDate={addBusinessDays(new Date(), minDateGap())}
          selected={date}
          setValue={updateOnDemandPicker}
          startDate={date}
          endDate={endDate}
          excludeDates={holidays}
          selectsRange={isDaily}
          inline
        />
        {!isDaily && (
          <div className={"ws-filter-timepicker"}>
            <OnDemandTimePicker
              startDate={date}
              startTime={startTime}
              setStartTime={(value) => setStartTime(value)}
              endTime={endTime}
              setEndTime={(value) => setET(value)}
              className={"mt-3 mb-1"}
            />
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={"weekend-disabled"}>
      <DatePicker
        value={date}
        onSelect={updateDatepicker}
        inline
        maxDate={new Date(moment().add("60", "days").format())}
      />
    </div>
  )
}

const TeamSize = ({ id, value, setValue, setFilter = () => null, title }) => {
  const [showSpaceType, setShowSpaceType] = useState(false)
  const [spaceType, setSpaceType] = useState("Private Office")
  const [teamSize, setTeamSize] = useState(1)

  const updateTeamSize = (teamSize) => {
    if (Number(teamSize) < 3 && !isOnDemand()) {
      setShowSpaceType(true)
      setTeamSize(teamSize)
    } else {
      setValue(teamSize)
      updateQueryString(`${id},space_type`, `${teamSize},${spaceType}`)
      setFilter(null)
    }
  }

  const setSpaceTypeAndSearch = (type) => {
    setSpaceType(type)
    setValue(teamSize)
    updateQueryString(`${id},space_type`, `${teamSize},${type}`)
    setFilter(null)
  }

  //Dedicated%20desks

  return (
    <div
      className="team-size-wrapper mt-0"
      onClick={(e) => e.stopPropagation()}
    >
      <div className={`form-group team-size-selector show`}>
        {!showSpaceType && <h4 className={"mt-0"}>{title}</h4>}
        {showSpaceType ? (
          <SpaceTypeSwitcher
            search={setSpaceTypeAndSearch}
            back={() => setShowSpaceType(false)}
          />
        ) : (
          <TeamSizeList updateTeamSize={updateTeamSize} value={value} />
        )}
      </div>
    </div>
  )
}

const types = ["Private Offices", "Dedicated desks"]

export const SpaceTypeSwitcher = ({ search, back }) => {
  return (
    <div>
      <h5>What kind of workspace are you looking for?</h5>
      {types.map((type) => (
        <button
          className="btn btn-primary space-type-button"
          onClick={() => search(type)}
          key={type}
        >
          {type}
        </button>
      ))}

      <button className="btn btn-link chev-left" onClick={back}>
        Back
      </button>
    </div>
  )
}

export const TeamSizeList = ({ updateTeamSize, value }) => {
  const teamSizes = isOnDemand() ? onDemandTeamSizeArray : teamSizeArray
  return (
    <ul>
      {teamSizes.map((number) => (
        <li
          key={number}
          onClick={() => updateTeamSize(number.toString())}
          className={value === number.toString() ? "active" : ""}
        >
          {number}
        </li>
      ))}

      {!isOnDemand() ? (
        <li
          className={`long ${value === "21-50" ? "active" : ""}`}
          onClick={() => updateTeamSize("21-50")}
        >
          21-50
        </li>
      ) : (
        <li
          className={`long-3 ${value === "13-20" ? "active" : ""}`}
          onClick={() => updateTeamSize("13-20")}
        >
          13-20
        </li>
      )}
      {!isOnDemand() ? (
        <li
          className={`long ${value === "51-100" ? "active" : ""}`}
          onClick={() => updateTeamSize("51-100")}
        >
          51-100
        </li>
      ) : (
        <li
          className={`long-3 ${value === "21-30" ? "active" : ""}`}
          onClick={() => updateTeamSize("21-30")}
        >
          21-30
        </li>
      )}
    </ul>
  )
}

const teamSizeArray = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
]

const onDemandTeamSizeArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
